import FullCalendar from "@fullcalendar/react";
import { Calendar } from "primereact/calendar";
import styled from "styled-components";

interface ILegendContainerProps {
    role: boolean;
    children?: JSX.Element | JSX.Element[];
}

const StyledFullCalendar = styled(FullCalendar)`
    width: 100%;
`;

const StyledLabel = styled.span`
    font-weight: 400;
    font-size: 16px;
    line-height: 48px;
    margin: 0;
    margin-right: 32px;
    margin-left: 8px;
`;

const StyledLabelStrong = styled.span`
    font-size: 15px;
    margin: 0 18px 0 5px;
`;

const StyledCalendar = styled(Calendar)`
    &.p-calendar .p-inputtext {
        border: transparent !important;
        background: #f0f2f2;
        cursor: pointer;
        font-size: 17px;
        line-height: 150%;
    }
`;

const LegendContainer = styled.div<ILegendContainerProps>`
    width: 1280px;
    height: 48px;
    background-color: #ffffff;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.12);
    border-radius: 2px;
    position: absolute;
    top: ${(props: { role?: boolean }) => (props.role ? 450 : 300)}px;
    right: 40px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    align-content: center;
    z-index: 10;
`;

const LegendItem = styled.div<{ color: string }>`
    width: 16px;
    height: 16px;
    background-color: ${(props) => props.color};
    border-radius: 2px;
`;

const LegendStyledTitleContainer = styled.div`
    font-size: 12px;
    font-weight: 400;
    line-height: 14.4px;
    margin: 0;
`;

const StyledLegendDiv = styled.div`
    display: flex;
    position: absolute;
    right: 5%;
    margin-top: 30px;

    @media (max-width: 1500px) {
        flex-direction: column;
        margin-top: 15px;
    }
    @media (max-width: 1100px) {
        margin-top: 5px;
    }
`;

const StyledLegendChildren = styled.div`
    display: flex;

    @media (max-width: 1100px) {
        flex-direction: column;
    }
`;

const StyledColorLegend = styled.div`
    display: flex;
    align-items: center;
`;

export {
    StyledFullCalendar,
    StyledLabel,
    StyledLabelStrong,
    StyledCalendar,
    LegendContainer,
    LegendItem,
    LegendStyledTitleContainer,
    StyledLegendDiv,
    StyledLegendChildren,
    StyledColorLegend,
};
